import { render, staticRenderFns } from "./Crosswalk.vue?vue&type=template&id=55ef896c"
import script from "./Crosswalk.vue?vue&type=script&lang=js"
export * from "./Crosswalk.vue?vue&type=script&lang=js"
import style0 from "./Crosswalk.vue?vue&type=style&index=0&id=55ef896c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports